module.exports = __webpack_public_path__ + "static/media/onboarding-auto-access.es.ea07f95d.png";